import { SCHOOLY_API_V2_URL } from 'libs/api/src/config';
import {
  buildArchiveCodeApiV2AttendanceCodesCodeIdDeletePath,
  buildConfigureAttendanceFrequenciesApiV2AttendanceFrequenciesForSchoolSchoolIdPatchPath,
  buildCreateCodesForSchoolApiV2AttendanceCodesForSchoolSchoolIdPostPath,
  buildCreateRegisterForSchoolApiV2AttendanceRegisterForSchoolSchoolIdPostPath,
  buildDeleteRegisterApiV2AttendanceRegisterRegisterIdDeletePath,
  buildEditRegisterApiV2AttendanceRegisterRegisterIdPatchPath,
  buildExportAttendanceForSchoolApiV2ExportAttendanceSchoolIdGetPath,
  buildExportFireRegisterApiV2ExportAttendanceFireRegisterGetPath,
  buildGetAttendanceCountsForSchoolApiV2AttendanceForSchoolSchoolIdCountsGetPath,
  buildGetCodesForSchoolApiV2AttendanceCodesForSchoolSchoolIdGetPath,
  buildGetEligibleGroupsForRegisterApiV2AttendanceRegistersEligibleGroupsForSchoolSchoolIdGetPath,
  buildGetGroupAttendanceAggregateApiV2AttendanceForGroupGroupIdAggregateGetPath,
  buildGetGroupEntriesForDateApiV2AttendanceForGroupGroupIdEntriesForDateGetPath,
  buildGetJustificationsListForSchoolApiV2AttendanceJustificationsForSchoolSchoolIdGetPath,
  buildGetRegisterApiV2AttendanceRegisterRegisterIdGetPath,
  buildGetRelationAttendanceAggregateApiV2AttendanceForRelationRelationIdAggregateGetPath,
  buildGetRelationAttendanceTrackingPointsAggregateApiV2AttendanceForRelationRelationIdAggregateTrackingPointsGetPath,
  buildGetRegisterStatisticsApiV2AttendanceRegisterRegisterIdStatisticsGetPath,
  buildGetSchoolStatisticsApiV2AttendanceRegistersForSchoolSchoolIdStatisticsGetPath,
  buildListRegistersApiV2AttendanceRegistersForSchoolSchoolIdGetPath,
  buildRedefineCodeApiV2AttendanceCodesForAttendanceAttendanceCodeIdPatchPath,
  buildReorderCodesApiV2AttendanceCodesOrderForSchoolSchoolIdPatchPath,
  buildUpsertAttendanceEntriesForGroupApiV2AttendanceForGroupGroupIdEntriesPostPath,
  buildUpsertAttendanceEntryForRelationApiV2AttendanceEntriesForRegisterRegisterIdForRelationRelationIdPostPath,
} from '../../generated/schooly-api-v2';

// Paths (aliased builders for convenient imports)
export const attendanceCodesListPath = (params: { school_id: string }) =>
  `${SCHOOLY_API_V2_URL}${buildGetCodesForSchoolApiV2AttendanceCodesForSchoolSchoolIdGetPath(params)}`;
export const attendanceCodesCreatePath = (params: { school_id: string }) =>
  `${SCHOOLY_API_V2_URL}${buildCreateCodesForSchoolApiV2AttendanceCodesForSchoolSchoolIdPostPath(params)}`;
export const attendanceCodesEditPath = (params: { attendance_code_id: string }) =>
  `${SCHOOLY_API_V2_URL}${buildRedefineCodeApiV2AttendanceCodesForAttendanceAttendanceCodeIdPatchPath(params)}`;
export const attendanceCodesOrderPath = (params: { school_id: string }) =>
  `${SCHOOLY_API_V2_URL}${buildReorderCodesApiV2AttendanceCodesOrderForSchoolSchoolIdPatchPath(params)}`;
export const attendanceCodesDeletePath = (params: { code_id: string }) =>
  `${SCHOOLY_API_V2_URL}${buildArchiveCodeApiV2AttendanceCodesCodeIdDeletePath(params)}`;
export const attendanceEntriesForDateListPath = (params: { group_id: string }) =>
  `${SCHOOLY_API_V2_URL}${buildGetGroupEntriesForDateApiV2AttendanceForGroupGroupIdEntriesForDateGetPath(params)}`;
export const attendanceEntryCreatePath = (params: { register_id: string; relation_id: string }) =>
  `${SCHOOLY_API_V2_URL}${buildUpsertAttendanceEntryForRelationApiV2AttendanceEntriesForRegisterRegisterIdForRelationRelationIdPostPath(params)}`;
export const justificationsListPath = (params: { school_id: string }) =>
  `${SCHOOLY_API_V2_URL}${buildGetJustificationsListForSchoolApiV2AttendanceJustificationsForSchoolSchoolIdGetPath(params)}`;
export const attendanceRegistersListPath = (params: { school_id: string }) =>
  `${SCHOOLY_API_V2_URL}${buildListRegistersApiV2AttendanceRegistersForSchoolSchoolIdGetPath(params)}`;
export const attendanceStatisticsPath = (params: { school_id: string }) =>
  `${SCHOOLY_API_V2_URL}${buildGetSchoolStatisticsApiV2AttendanceRegistersForSchoolSchoolIdStatisticsGetPath(params)}`;
export const attendanceRegisterPath = (params: { register_id: string }) =>
  `${SCHOOLY_API_V2_URL}${buildGetRegisterApiV2AttendanceRegisterRegisterIdGetPath(params)}`;
export const registerCompositionPath = attendanceRegisterPath;
export const attendanceRegisterStatisticsPath = (params: { register_id: string }) =>
  `${SCHOOLY_API_V2_URL}${buildGetRegisterStatisticsApiV2AttendanceRegisterRegisterIdStatisticsGetPath(params)}`;
export const attendanceEntriesCreatePath = (params: { group_id: string }) =>
  `${SCHOOLY_API_V2_URL}${buildUpsertAttendanceEntriesForGroupApiV2AttendanceForGroupGroupIdEntriesPostPath(params)}`;
export const attendanceCountsPath = (params: { school_id: string }) =>
  `${SCHOOLY_API_V2_URL}${buildGetAttendanceCountsForSchoolApiV2AttendanceForSchoolSchoolIdCountsGetPath(params)}`;

export const exportFireRegisterPath = () =>
  `${SCHOOLY_API_V2_URL}${buildExportFireRegisterApiV2ExportAttendanceFireRegisterGetPath()}`;

export const exportAttendanceForSchoolPath = (params: { school_id: string }) =>
  `${SCHOOLY_API_V2_URL}${buildExportAttendanceForSchoolApiV2ExportAttendanceSchoolIdGetPath(params)}`;

export const buildEligibleRegisterGroupsPath =
  buildGetEligibleGroupsForRegisterApiV2AttendanceRegistersEligibleGroupsForSchoolSchoolIdGetPath;

export const eligibleRegisterGroupsPath = (params: { school_id: string }) =>
  `${SCHOOLY_API_V2_URL}${buildEligibleRegisterGroupsPath(params)}`;

export const groupAttendanceAggregatePath = (params: { group_id: string }) =>
  `${SCHOOLY_API_V2_URL}${buildGetGroupAttendanceAggregateApiV2AttendanceForGroupGroupIdAggregateGetPath(params)}`;

export const createRegisterPath =
  buildCreateRegisterForSchoolApiV2AttendanceRegisterForSchoolSchoolIdPostPath;

export const createRegisterForSchoolPath = (params: { school_id: string }) =>
  `${SCHOOLY_API_V2_URL}${createRegisterPath(params)}`;

export const editRegisterPath = buildEditRegisterApiV2AttendanceRegisterRegisterIdPatchPath;

export const editRegisterForSchoolPath = (params: { register_id: string }) =>
  `${SCHOOLY_API_V2_URL}${editRegisterPath(params)}`;

export const deleteRegisterPath = buildDeleteRegisterApiV2AttendanceRegisterRegisterIdDeletePath;

export const deleteRegisterForSchoolPath = (params: { register_id: string }) =>
  `${SCHOOLY_API_V2_URL}${deleteRegisterPath(params)}`;

export const buildRelationAttendanceAggregatePath =
  buildGetRelationAttendanceAggregateApiV2AttendanceForRelationRelationIdAggregateGetPath;

export const relationAttendanceAggregatePath = (params: { relation_id: string }) =>
  `${SCHOOLY_API_V2_URL}${buildRelationAttendanceAggregatePath(params)}`;

export const buildRelationTrackingPointsAggregatePath =
  buildGetRelationAttendanceTrackingPointsAggregateApiV2AttendanceForRelationRelationIdAggregateTrackingPointsGetPath;

export const relationTrackingPointsAggregatePath = (params: { relation_id: string }) =>
  `${SCHOOLY_API_V2_URL}${buildRelationTrackingPointsAggregatePath(params)}`;

export const configureAttendanceFrequenciesPath = (params: { school_id: string }) =>
  `${SCHOOLY_API_V2_URL}${buildConfigureAttendanceFrequenciesApiV2AttendanceFrequenciesForSchoolSchoolIdPatchPath(params)}`;
